import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GenericModalSettings } from '../models/generic-modal-settings';
import { AccountService } from './account.service';

@Injectable({
	providedIn: 'root'
})
export class UiService {

	private _loading = new BehaviorSubject<boolean>(false);
	private _showGenericModal = new BehaviorSubject<boolean>(false);

	private genericModalSettings: GenericModalSettings = {
		title: '',
		body: '',
		close: false,
		closeLabel: '',
		okLabel: '',
		elementFocusCallback: undefined,
		okCallback: undefined,
	};


	get loading(): Observable<boolean> {
		return this._loading.asObservable();
	}

	get isLoading(): boolean {
		return this._loading.getValue();
	}

	get genericModal(): Observable<boolean> {
		return this._showGenericModal.asObservable();
	}

	constructor(private accountService: AccountService) {
	}

	startLoading(): void {
		this._loading.next(true);
	}

	stopLoading(): void {
		this._loading.next(false);
	}

    get isModalOpen() {
        return this._showGenericModal.getValue();
    }

	showGenericModal(): void {
		this._showGenericModal.next(true);
	}

	setGenericModalSettings(modalSettings: GenericModalSettings): void {
		this.genericModalSettings = modalSettings;
	}

	clearGenericModalSettings(): void {
		this.genericModalSettings = {
			title: '',
			body: '',
			close: false,
			closeLabel: '',
			okCallback: undefined,
			okLabel: '',
			elementFocusCallback: undefined
		}
	}

	getGenericModalSettings(): GenericModalSettings {
		return this.genericModalSettings;
	}

	stopShowingGenericModal(): void {
		this._showGenericModal.next(false);
	}

    showLogOutModal(elementFocusCallback?: () => void,) {
        this.setGenericModalSettings({
            title: "Are you sure?",
            body: "Please confirm.",
            okCallback: () => this.accountService.logoutUser(),
            okLabel: "LOG OUT",
            close: true,
            closeLabel: "NO",
            elementFocusCallback: elementFocusCallback
        })
        this.showGenericModal();
    }
}
